import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TsrSvgIcon, Icon } from 'tacho-ui';
import { ClipLoader } from '../ClipLoader';
import styles from './styles.module.scss';
interface TachoEditModalTitleProps {
    titleToTranslation?: string | JSX.Element;
    titleTranslated?: string;
    isLoading?: boolean;
    icon?: Icon;
    className?: string;
    iconViewBox?: string;
}

const loaderSize = 40;

export function TachoEditModalTitle(props: TachoEditModalTitleProps) {
    return (
        <>
            <div className={`${styles.TachoEditModalTitleAlignment} ${props.className || ''}`}>
                {props.isLoading ? (
                    <ClipLoader size={loaderSize} className={styles.titleLoader} color="accent" />
                ) : (
                    <TsrSvgIcon icon={props.icon} titleIcon className={styles.titleIcon} viewBox={props.iconViewBox} />
                )}
            </div>
            <div className={`${styles.TachoEditModalTitleAlignment} ${props.className || ''}`}>
                {props.titleTranslated}
                {typeof props.titleToTranslation === 'string' ? (
                    <FormattedMessage id={(props.titleToTranslation as string) || ''} />
                ) : (
                    props.titleToTranslation
                )}
            </div>
        </>
    );
}
